import Api from '../api'
import temperatureService from '../services/temperatureService'

class Authentication {

    authListener    = null as any;
    currentUser     = null as any;
    isSuperAdmin    = false as boolean;
    token           = null as any;

    onAuthStateChanged(listener : any) {
        this.authListener = listener;
        this.token = sessionStorage.getItem("token");
        if (this.token) {
            this.currentUser = this.decodeJwt(this.token);
            this.checkSuperAdmin(); 
            if (this.authListener) {
                this.authListener(this.currentUser);
            }
        }
    }


    async signInWithUserNameAndPassword(username : string, password : string, role_id? : string) {

        const params={
            username    :   username,
            password    :   password,
            role_id     :   role_id
        }

        let response = await Api.post('/login',params)
               
        this.token        = response.data.result;
        this.currentUser  = this.decodeJwt(this.token)
        this.checkSuperAdmin();
        sessionStorage.setItem("token", this.token);

        // Initialize asset type temperature unit cache after login
        temperatureService.initializeAssetTypeCache().catch(error => {
            console.error('Failed to initialize temperature unit cache:', error);
        });

        if (this.authListener) {
            this.authListener(this.currentUser);
        }
            
        return this.currentUser
                    
   }
    

    signOut() {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("profile");
        this.token       = null;
        this.currentUser = null;
        this.checkSuperAdmin(); 
        if (this.authListener) {
            this.authListener(null);
        }
    }

    decodeJwt(token : string) {
        var payload = token.split('.')[1];
        var base64 = payload.replace('-', '+').replace('_', '/');
        return JSON.parse(atob(base64));
    }

    checkSuperAdmin() {
        if (this.currentUser !== null && this.currentUser?.active_role?.role_type === 0) {
            this.isSuperAdmin = true;
        } else {
            this.isSuperAdmin = false;
        }
    }

    isOrgAdmin() {
        if (this.currentUser !== null && (this.currentUser?.active_role?.role_type === 0 
            || this.currentUser?.active_role?.role_type === 1)) {
            return true;
        } else {
            return false;
        }
    }
}

const appAuth = new Authentication()
export default appAuth